import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import api from "APP_ROOT/api";
import { dollars } from "LIB/formatters/currency";
import { DataTable } from "MODULES/shared/components";
import moment from "moment";
import _ from "lodash";
import SimpleDateRangePicker from "MODULES/shared/components/SimpleDateRangePicker/SimpleDateRangePicker";
import { setDateLabel } from "MODULES/shared/helpers";
import { API_BASE, MONTH } from "APP_ROOT/constants";
import MonthlyStats from "./MonthlyStats";
import HeaderStats from "./HeaderStats";
import QuarterlyStats from "./QuarterlyStats";

function renderRow(r) {
  const percentProfit =
    r.total_sales !== 0 ? r.total_profit / r.total_sales * 100 : 0;
  const percentProfitQuarter =
    r.total_sales_quarter !== 0
      ? r.total_profit_quarter / r.total_sales_quarter * 100
      : 0;

  const percentProfitYtd =
    r.total_sales_ytd !== 0 ? r.total_profit_ytd / r.total_sales_ytd * 100 : 0;

  return (
    <tr key={r.seller}>
      <td>{r.seller}</td>
      <td className="text-right">{dollars(r.total_sales)}</td>
      <td className="text-right">{dollars(r.total_profit)}</td>
      <td className="text-right">
        {percentProfit ? percentProfit.toFixed(1) : "N/A"}
      </td>
      <td className="text-right">{dollars(r.total_sales_quarter)}</td>
      <td className="text-right">{dollars(r.total_profit_quarter)}</td>
      <td className="text-right">
        {percentProfitQuarter ? percentProfitQuarter.toFixed(1) : "N/A"}
      </td>
      <td className="text-right">{dollars(r.total_sales_ytd)}</td>
      <td className="text-right">{dollars(r.total_profit_ytd)}</td>
      <td className="text-right">
        {percentProfitYtd ? percentProfitYtd.toFixed(1) : "N/A"}
      </td>
    </tr>
  );
}

export class Table extends Component {
  constructor() {
    super();
    this.fetchMonthResults = this.fetchMonthResults.bind(this);
    this.fetchYtdResults = this.fetchYtdResults.bind(this);
    this.fetchTodaysResults = this.fetchTodaysResults.bind(this);
    this.fetchQuarterResults = this.fetchQuarterResults.bind(this);
    this.state = {
      monthResults: [],
      todaysResults: [],
      quarterResults: [],
      ytdResults: [],
      sellers: {},
      monthlyDataLoading: true,
      startDate: moment()
        .startOf(MONTH)
        .format(),
      endDate: moment()
        .endOf(MONTH)
        .format()
    };
  }

  componentDidMount() {
    this.fetchTodaysResults();
    this.fetchMonthResults();
    this.fetchQuarterResults();
    this.fetchYtdResults();
  }

  fetchTodaysResults() {
    const startTime = moment()
      .startOf("day")
      .format();
    const endTime = moment()
      .endOf("day")
      .format();

    api.reports.sales.search(startTime, endTime).then(res => {
      this.setState({
        todaysResults: res.data,
        monthlyDataLoading: false
      });
    });
  }

  fetchQuarterResults() {
    let dateString = this.state.startDate;
    if (!dateString) {
      const d = new Date();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear().toString();
      dateString = `${year}-${month}`;
    }

    const currentMoment = moment(dateString, "YYYY-MM");
    const startTime = currentMoment.startOf("quarter").format();
    const endTime = currentMoment.endOf("quarter").format();
    api.reports.sales.search(startTime, endTime).then(res => {
      const sellers = res.data.sellers.filter(
        v => Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0
      );
      const adjustedSellers = _.map(sellers, seller => ({
        id: seller.id,
        seller: seller.seller,
        total_profit_quarter: seller.total_profit,
        total_sales_quarter: seller.total_sales
      }));

      this.setState(state => ({
        sellers: _.values(
          _.merge(
            {},
            _.keyBy(state.sellers, "id"),
            _.keyBy(adjustedSellers, "id")
          )
        ),
        quarterResults: res.data,
        monthlyDataLoading: false
      }));
    });
  }

  fetchYtdResults() {
    let dateString = this.state.startDate;
    if (!dateString) {
      const d = new Date();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear().toString();
      dateString = `${year}-${month}`;
    }

    const currentMoment = moment(dateString, "YYYY-MM");
    const startTime = currentMoment.startOf("year").format();
    const endTime = currentMoment.endOf("year").format();
    api.reports.sales.search(startTime, endTime).then(res => {
      const sellers = res.data.sellers.filter(
        v => Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0
      );
      const adjustedSellers = _.map(sellers, seller => ({
        id: seller.id,
        seller: seller.seller,
        total_profit_ytd: seller.total_profit,
        total_sales_ytd: seller.total_sales
      }));

      this.setState(state => ({
        sellers: _.values(
          _.merge(
            {},
            _.keyBy(state.sellers, "id"),
            _.keyBy(adjustedSellers, "id")
          )
        ),
        ytdResults: res.data,
        monthlyDataLoading: false
      }));
    });
  }

  fetchMonthResults() {
    const { endDate, startDate } = this.state;

    api.reports.sales.search(startDate, endDate).then(res => {
      const sellers = res.data.sellers.filter(
        v => Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0
      );

      this.setState(state => ({
        sellers: _.values(
          _.merge({}, _.keyBy(state.sellers, "id"), _.keyBy(sellers, "id"))
        ),
        monthResults: res.data,
        monthlyDataLoading: false
      }));
    });
  }

  reportTime = selectedDate => moment(selectedDate).format();

  handleDateChange = (startDate, endDate, label) => {
    this.setState(
      {
        sellers: {},
        monthlyDataLoading: true,
        startDate,
        endDate,
        label
      },
      () => {
        if (startDate) {
          this.fetchMonthResults();
          this.fetchQuarterResults();
          this.fetchYtdResults();
        } else {
          this.setState({
            monthResults: [],
            monthlyDataLoading: false
          });
        }
      }
    );
  };

  render() {
    const {
      todaysResults,
      monthResults,
      quarterResults,
      label,
      monthlyDataLoading,
      sellers,
      selectedDate,
      startDate,
      endDate
    } = this.state;

    return (
      <React.Fragment>
        {todaysResults.sellers && (
          <HeaderStats
            salesData={todaysResults}
            refresh={this.fetchTodaysResults}
          />
        )}
        <Row>
          <Col>
            <div
              className="page-header monthly-sales-header"
              style={{ padding: "10px, 30px" }}
            >
              <h1 style={{ marginTop: "7px" }}>
                <span className="header-content">
                  <span style={{ marginRight: "10px", verticalAlign: "super" }}>
                    {setDateLabel(startDate, endDate, label)}
                  </span>
                  <div style={{ display: "inline-block" }}>
                    <SimpleDateRangePicker
                      handleDateChange={this.handleDateChange}
                    />
                  </div>
                </span>
              </h1>
              {monthResults.sellers && (
                <a
                  href={`${API_BASE}/monthly_sales/download.xls?start_time=${this.reportTime(
                    startDate
                  )}&end_time=${this.reportTime(endDate)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginTop: "7px" }}
                >
                  <button
                    className={`btn btn-primary btn-hollow pull-right`}
                    type="button"
                  >
                    <i className="fa fa-lg fa-cloud-download" />
                    &nbsp;&nbsp;Download Report
                  </button>
                </a>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DataTable loading={monthlyDataLoading} loadingRows={40}>
              <DataTable.Head>
                <th>Name</th>
                <th className="text-right">Total Sales</th>
                <th className="text-right">Total Profit</th>
                <th className="text-right">Profit %</th>
                <th className="text-right">Total Sales QTD</th>
                <th className="text-right">Total Profit QTD</th>
                <th className="text-right">Profit % QTD</th>
                <th className="text-right">Total Sales YTD</th>
                <th className="text-right">Total Profit YTD</th>
                <th className="text-right">Profit % YTD</th>
              </DataTable.Head>
              <DataTable.Body>
                {_.size(sellers) > 0
                  ? _.map(
                      _.orderBy(
                        sellers,
                        ({ total_sales }) => total_sales || 0, // eslint-disable-line camelcase
                        "desc"
                      ),
                      r => renderRow(r)
                    )
                  : []}
              </DataTable.Body>
            </DataTable>
          </Col>
        </Row>
        {_.size(monthResults) > 0 && (
          <MonthlyStats
            selectedDate={startDate}
            salesData={monthResults}
            customRange={label}
            refresh={this.fetchMonthResults}
          />
        )}
        {_.size(quarterResults) > 0 && (
          <QuarterlyStats
            selectedDate={selectedDate}
            salesData={quarterResults}
            refresh={this.fetchQuarterResults}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/Components/Table.jsx